import { GetGeneralResultsByCategoryResponseDTO } from '@/core/dto/psychosocial-report';
import type { GetGeneralResultsByCategoryResponse } from '@/types/Psychosocial';

export class GetGeneralResultsByCategoryMapper {
	constructor(private readonly data: GetGeneralResultsByCategoryResponseDTO) {}

	toDomain(): GetGeneralResultsByCategoryResponse {
		const result = { ...this.data };

		if (result.nasa_tlx && result.nasa_tlx) {
			result.nasa_final_score = result.nasa_tlx.find((item) => item.category === 'final_score')!;
			result.nasa_tlx = result.nasa_tlx.filter(
				(item) => !['workload', 'final_score'].includes(item.category) && item.category !== null
			);
		}

		if (result.hse_it && Array.isArray(result.hse_it)) {
			result.hse_it = result.hse_it.filter((item) => item.category !== null);
		}

		result.risk_matrix_hse_it = [...result.risk_matrix_hse_it];
		result.risk_matrix_nasa_tlx = [...result.risk_matrix_nasa_tlx];

		return result;
	}
}
